import React, { useState, useEffect } from "react";
import Autocomplete from "react-autocomplete";
import Img from "gatsby-image";
import { useFlexSearch } from "react-use-flexsearch";
import { useStaticQuery, graphql } from "gatsby";
import { getLocalSearchQuery } from "../utils/functions";

const ComparisonSearch = ({ onSelectOption, availableBoards, category }) => {
  const data = useStaticQuery(graphql`
    query {
      mcuLocalSearch: localSearchCompareMCUs {
        ...MCULocalSearchFields
      }
      sbcLocalSearch: localSearchCompareSBCs {
        ...SBCLocalSearchFields
      }
    }
  `);
  const [results, setResults] = useState([]);
  const [query, setQuery] = useState("");

  const localSearchQuery = getLocalSearchQuery(category);
  const nodes = useFlexSearch(
    query,
    data[localSearchQuery].index,
    JSON.parse(data[localSearchQuery].store),
    {
      encode: "forward",
      tokenize: "full",
      threshold: 3,
      depth: 3,
      resolution: 3,
      limit: 0,
    }
  );
  const onChange = event => {
    const userInput = event.target.value;
    setQuery(userInput);
    // search(userInput);
  };
  const search = userInput => {
    if (userInput.length > 2) {
      let filteredResults = [];
      if (nodes.length > 0) {
        filteredResults = getFilteredResults(nodes);
      }
      // console.log("results", filteredResults);
      setResults([...filteredResults]);
      setQuery(userInput);
    } else {
      setResults([]);
      setQuery(userInput);
    }
  };

  useEffect(() => {
    let found = [];
    if (nodes.length > 0) found = getFilteredResults();

    setResults([...found]);
  }, [availableBoards, query]);

  const getFilteredResults = () =>
    nodes.filter(node => availableBoards.some(board => node.id === board.id));

  const renderResult = (item, isHighlighted) => {
    // console.log("found item", item);
    return (
      <div
        key={item.id}
        className={`cursor-pointer flex p-2 autocomplete-item${
          isHighlighted ? " bg-primary" : ""
        }`}
      >
        <div className="w-16 mr-2">
          <Img fluid={item.img.childImageSharp.fluid} />
        </div>
        <h3 className={`bold text-base${isHighlighted ? " text-white" : ""}`}>
          {item.title}
        </h3>
      </div>
    );
  };

  const renderMenu = (items, value, style) => (
    <div
      className="bg-white overflow-y-auto h-40 shadow-md z-50 w-full"
      style={{ position: "absolute" }}
      children={items}
    />
  );
  // console.table(results.map(result => result.title));
  return (
    // <div className="h-full">
    <Autocomplete
      onChange={onChange}
      items={results}
      renderItem={renderResult}
      value={query}
      getItemValue={item => item.title}
      onSelect={(...args) => {
        onSelectOption(...args);
        setQuery("");
        // search(query);
      }}
      wrapperProps={{ className: "w-full mb-12 sm:w-1/2 relative" }}
      wrapperStyle={{ display: "block" }}
      inputProps={{
        className:
          "appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded-md py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:rounded-t-md focus:rounded-b-none",
      }}
      // menuStyle={{ boxShadow: "none", overflowY: "auto", maxHeight: "100%" }}
      renderMenu={renderMenu}
    />
    // </div>
  );
};

export default ComparisonSearch;
